import { call, put, select } from 'typed-redux-saga';

import { NOTIFICATIONS_MAP, notify } from '../../../../../shared/features/notifications/ps-notifications';
import { createLogger } from '../../../../../shared/helpers/loggerFacade';
import { countMetrika } from '../../../../../shared/helpers/metrika';
import { cloudApi } from '../../../../../shared/helpers/transport';
import { isNonCriticalFetchError } from '../../../helpers/handlers-sagas/handle-fetch-error';
import { getConferenceConfig, getMyUserId } from '../../../selectors';
import { NotificationId } from '../../../types';
import { setReactionAction } from '../slice';

const logger = createLogger('goloom:reaction');

export function* setReactionSaga({ payload }: ReturnType<typeof setReactionAction>) {
    const { reactionType, reason = 'click' } = payload;
    const conferenceConfig = yield* select(getConferenceConfig);
    const myUserId = yield* select(getMyUserId);

    if (!conferenceConfig || !myUserId) {
        return;
    }

    try {
        yield* call([cloudApi, cloudApi.setPeerReaction], conferenceConfig.resolved_uri, myUserId, {
            reaction_type: reactionType,
            reason,
        });
    } catch (error) {
        yield* put(notify(NOTIFICATIONS_MAP[NotificationId.SET_REACTION_ERROR]()));

        yield* call(countMetrika, 'meeting_screen', 'hand_and_reactions', 'error');

        logger.error(error, {
            level: isNonCriticalFetchError(error) ? 'warning' : 'error',
            method: 'setReactionSaga',
        });
    }
}
